import { render, staticRenderFns } from "./TicketsData.vue?vue&type=template&id=08589fe7&scoped=true&"
import script from "./TicketsData.vue?vue&type=script&lang=js&"
export * from "./TicketsData.vue?vue&type=script&lang=js&"
import style0 from "./TicketsData.vue?vue&type=style&index=0&id=08589fe7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08589fe7",
  null
  
)

export default component.exports